import { Container } from 'pixi.js';

/** Ascending projected ground contact; stable identity resolves only exact ties. */
export function compareGroundDepth(
  a: { zIndex: number; label: string },
  b: { zIndex: number; label: string },
): number {
  const depth = a.zIndex - b.zIndex;
  if (depth !== 0) return depth;
  return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
}

/** Pixi's automatic sort path uses the same deterministic ordering as explicit frame sorts. */
export class WorldDepthContainer extends Container {
  override sortChildren = (): void => {
    if (!this.sortDirty) return;
    this.sortDirty = false;
    this.children.sort(compareGroundDepth);
  };
}
